module.exports = __webpack_public_path__ + "img/2keinstellungen_2.b418b286.png";